import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;

    /* ✅ Firefox support */
    scrollbar-width: auto;
    scrollbar-color: var(--text-light) var(--text-dark);
  }

  /* ✅ WebKit Browsers (Chrome, Safari, Edge) */
  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background: var(--text-dark);
    border-radius: 20px;
  }

  *::-webkit-scrollbar-thumb {
    background-color: var(--text-light);
    border-radius: 20px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  *::-webkit-scrollbar-button {
    display: none;
  }

  *::-webkit-scrollbar-corner {
    background: var(--text-dark);
  }

  body > #root > div {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  body, :root {
    background-color: #dddada;
    overflow: hidden;
  }

  :root {
    --text-light: #FFFBEC;
    --text-dark: #72969B;
    --text-ultra-dark: #3E626A;

    --button: #FE6030;
    --button-inactive: #F3DE8A;
    --button-success: #536245;
    --button-error: #C33636;
    --button-bg: #BE2E03;

    --link-active: #F3DE8A;
    --link-inactive: #72969B;

    --highlight: #F3DE8A;

    --bar-bg: #3E626A;
    --bar-active: #FE6030;
    --bar-inactive: #F3DE8A;

    --audio-active: #FE6030;
    --audio-inactive: #FFFBEC;

    --bg-dark-blue: #3E626A;
    --bg-light-blue: #72969B;
  }

  /* ✅ Optional: Scoped scrollBar class for containers with overflow */
  .scrollBar {
    scrollbar-width: auto;
    scrollbar-color: var(--text-light) var(--text-dark);
  }

  .scrollBar::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .scrollBar::-webkit-scrollbar-track {
    background: var(--text-dark);
    border-radius: 20px;
  }

  .scrollBar::-webkit-scrollbar-thumb {
    background-color: var(--text-light);
    border-radius: 20px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  .scrollBar::-webkit-scrollbar-button {
    display: none;
  }
`;
